export type Segment = { kind: 'protocol' | 'session'; id: string };

export function protocolSegments(ids: string[]): Segment[] {
  return ids.map((id) => ({ kind: 'protocol', id }));
}

// The ~55-minute Full Protocol: the four breath protocols, then the two
// guided sessions (Stillness is a separate standalone).
export const FULL_PROTOCOL: Segment[] = [
  { kind: 'protocol', id: 'descent' },
  { kind: 'protocol', id: 'pranic' },
  { kind: 'protocol', id: 'coherence' },
  { kind: 'protocol', id: 'void' },
  { kind: 'session', id: 'heartBrain' },
  { kind: 'session', id: 'fieldExpansion' },
];
